/**
 * Prazo padrão de cada motivo do exame clínico, nos termos da NR-7, que o formulário põe nos
 * campos vazios quando um exame novo passa a ser clínico (#421).
 *
 * Os mesmos textos que a migration 305 gravou nos exames já cadastrados
 * (`backend/src/database/migrations/305-add-exam-deadlines-by-reason.ts`); um teste de cada lado
 * trava o texto literal.
 */
export const PRAZOS_PADRAO_DO_EXAME_CLINICO = {
  admissionDeadline: 'Antes de assumir as atividades',
  returnToWorkDeadline: 'Antes de reassumir as funções, após ausência de 30 dias ou mais',
  riskChangeDeadline: 'Antes da data da mudança',
  dismissalDeadline:
    'Até 10 dias do término do contrato; dispensado se o último exame tiver menos de 135 dias (grau de risco 1 e 2) ou 90 dias (3 e 4)',
} as const;

export type CampoDePrazoDoExame = keyof typeof PRAZOS_PADRAO_DO_EXAME_CLINICO;
